import React, { useEffect, useRef } from "react";

export default function ContactThanksModal({ isOpen, onClose }) {
  const overlayRef = useRef(null);
  const modalRef = useRef(null);
  const lastActiveRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    lastActiveRef.current = document.activeElement;

    const t = window.setTimeout(() => {
      const btn = modalRef.current?.querySelector("button");
      if (btn) btn.focus();
    }, 0);

    function onKeyDown(e) {
      if (e.key === "Escape") onClose();
    }

    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.clearTimeout(t);
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
      const el = lastActiveRef.current;
      if (el && el.focus) el.focus();
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="thanksOverlay"
      ref={overlayRef}
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose();
      }}
    >
      <div
        className="thanksModal"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label="Thank you"
      >
        <div className="thanksGlow" aria-hidden="true" />
        <div className="thanksTop">
          <div className="thanksBadge" aria-hidden="true">
            <span className="thanksDot" />
            Message sent
          </div>
          <button className="iconBtn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="thanksTitle">Thanks for contacting us.</div>
        <div className="thanksBody">
          Your message has been received. Your mail will be reviewed and you
          will receive feedback within 48 hours.
        </div>

        <div className="thanksActions">
          <button className="btn btn--primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
